<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "ReplicantiGalaxyModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      replicanti: new Decimal(),
      divideReplicanti: false,
      canBeBought: 0,
    };
  },
  computed: {
    topLabel() {
      return `Вы собираетесь приобрести ${ruQuantifyInt(
        "Галактику Репликантов,Галактики Репликантов,Галактик Репликантов", this.canBeBought)}`;
    },
    message() {
      const reductionString = this.divideReplicanti
        ? `поделит ваших Репликантов на ${format(Number.MAX_VALUE, 2, 2)} за каждую купленную Галактику Репликантов
          (с ${format(this.replicanti, 2, 2)} до
          ${format(this.replicanti.divide(Decimal.NUMBER_MAX_VALUE.pow(this.canBeBought)), 2, 2)})`
        : `сбросит количество Репликантов до ${formatInt(1)}`;
      return `Галактика Репликантов увеличивает Скорость Тика подобно Галактике Антиматерии, однако она не
        повышает цену Галактики Антиматрии и не зависит от множителей Галактик Антиматерии.
        Это ${reductionString}.`;
    }
  },
  methods: {
    update() {
      this.replicanti.copyFrom(player.replicanti.amount);
      this.divideReplicanti = Achievement(126).isUnlocked;
      this.canBeBought = Replicanti.galaxies.gain;
      if (this.replicanti.lt(Number.MAX_VALUE)) this.emitClose();
    },
    handleYesClick() {
      replicantiGalaxy(false);
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="replicantiGalaxy"
    @confirm="handleYesClick"
  >
    <template #header>
      {{ topLabel }}
    </template>
    <div class="c-modal-message__text">
      {{ message }}
    </div>
  </ModalWrapperChoice>
</template>
